/**
 *
 * @param {string} tenantName
 * @returns User-facing SSO name string for the tenant
 */
export const getFederationName = (tenantName) => {
  const federationNames = { ASU: 'ASURITE', SMC: 'SMC' };
  return federationNames[tenantName.toUpperCase()];
};
